import type {
  ParallelSubscriptionAddonPlan,
  SubscriptionBillingCycle,
  SubscriptionPlanType,
} from '@bugbug/core/types/subscriptions';
import useQueryString from '~/hooks/useQueryString';
import { useGetSubscriptionsPlansQuery } from '~/modules/subscriptions/subscriptions.api';

export const useSelectedSubscriptionProducts = () => {
  const { type, billingCycle, parallel } = useQueryString<{
    type: SubscriptionPlanType;
    billingCycle: SubscriptionBillingCycle;
    parallel: string;
  }>();

  return useGetSubscriptionsPlansQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => {
      const plan = data?.find((p) => p.type === type && p.billingCycle === billingCycle);
      if (!plan) {
        return {
          data: null,
          ...rest,
        };
      }

      const parallelQty = parseInt(parallel, 10);
      if (parallelQty === 0) {
        return {
          data: { plan, parallel: null },
          ...rest,
        };
      }

      const parallelAddon = plan.possibleAddons.find(
        (addon): addon is ParallelSubscriptionAddonPlan =>
          addon.type === 'extra_parallel_runs_limit' && addon.value === parallelQty,
      );
      if (!parallelAddon) {
        return {
          data: { plan, parallel: null },
          ...rest,
        };
      }

      return {
        data: { plan, parallel: parallelAddon },
        ...rest,
      };
    },
  });
};
